import { render, staticRenderFns } from "./ZhongyiSearch.vue?vue&type=template&id=482440f0&scoped=true"
import script from "./ZhongyiSearch.vue?vue&type=script&lang=js"
export * from "./ZhongyiSearch.vue?vue&type=script&lang=js"
import style0 from "./ZhongyiSearch.vue?vue&type=style&index=0&id=482440f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482440f0",
  null
  
)

export default component.exports